import { MutationTree } from "vuex";
import { UserState, UserMutations } from "@/store/interfaces/user";
import { MutationTypes } from "./mutation-types";

export const mutations: MutationTree<UserState> & UserMutations = {
  /**
    Mutation for user status from User module state
    @param state - User module state
    @param payload - {
      status: boolean,
      didInvalidate: boolean,
      receivedAt: number,
      connectionError: boolean,
      user: object
    }
  */
  [MutationTypes.SET_USER_STATUS](state, payload) {
    state.user = payload;
  },

  /**
    Mutation for user passwordReset status from User module state
    @param state - User module state
    @param payload - {
      status: boolean,
      didInvalidate: boolean,
      receivedAt: number,
      connectionError: boolean,
    }
  */
  [MutationTypes.SET_REQUEST_PASSWORD_RESET_STATUS](state, payload) {
    state.passwordReset = payload;
  },

  /**
    Mutation for register validation status from User module state
    @param state - User module state
    @param payload - {
      status: boolean,
      didInvalidate: boolean,
      receivedAt: number,
      connectionError: boolean,
      response: object
    }
  */
  [MutationTypes.SET_REGISTER_VALIDATION_STATUS](state, payload) {
    state.registerValidation = payload;
  },

  /**
    Mutation for register status from User module state
    @param state - User module state
    @param payload - {
      status: boolean;
      didInvalidate: boolean;
      receivedAt: number;
      flowState: string;
      email: string;
      error: boolean;
    }
  */
  [MutationTypes.SET_REGISTER_STATUS](state, payload) {
    state.register = payload;
  }
};
